import React from 'react'
import {connect} from 'react-redux'
import {withToggles} from 'startlibs/lib/hocs'
import {BasicInfoEditor,DicomDateFormatter} from 'report-components'
import {
  updateReportBasicInfo,
  updateReportBasicInfosOrder,
  deleteReportBasicInfo,
  addReportBasicInfo,
  autoSaveOrder,
  autoSaveRemove,
  autoSaveUpdate
} from 'report-components/lib/reducers'
import {getNewId, getItems, makeMapStateToProps} from 'report-components/lib/selectors'

const autoSaveType = {type: 'reportField'}

const ReportBasicInfoEditor = connect(
  makeMapStateToProps({getNewId, getItems})(({getNewId, getItems}) => ({report}) =>
    ({
      basicInfos: getItems(report.reportBasicInfos),
      labels: report.templates.infoLabels,
      dicomInfo: report.dicomInfo,
      newId: getNewId(report.reportBasicInfos),
      language: report.reportSettings.layout.language,
      dateFormat: report.reportSettings.layout.dateFormat,
      autoSaveType
    })),
  dispatch => ({
    addNew: (field, index) => dispatch(addReportBasicInfo(field, {index})),
    updateOrder: (newOrder) => {
      dispatch(updateReportBasicInfosOrder(newOrder))
      dispatch(autoSaveOrder(newOrder, autoSaveType))
    },
    updateItem: (item) => dispatch(updateReportBasicInfo(item)),
    removeItem: (id) => dispatch(deleteReportBasicInfo(id)),
    confirmRemoveItem: (id) => dispatch(autoSaveRemove(id, autoSaveType)),
    autoSaveUpdate: (item) => dispatch(autoSaveUpdate(item, autoSaveType))
  })
)(BasicInfoEditor)

const ReportDicomDateFormatter = connect(({report})=>({
    dicomInfo: report.dicomInfo,
    language: report.reportSettings.layout.language,
    dateFormat: report.reportSettings.layout.dateFormat
  }),
  dispatch => ({
    updateItem: (item) => dispatch(updateReportBasicInfo(item)),
    autoSaveUpdate: (item) => dispatch(autoSaveUpdate(item, autoSaveType))
  })
)(DicomDateFormatter)


@connect(
  makeMapStateToProps({getItems})(({getItems}) => ({report}) =>
    ({
      basicInfos: getItems(report.reportBasicInfos),
      dicomInfo: report.dicomInfo
    }))
)
@withToggles('editor')
export class ReportBasicInfo extends React.Component {

  render() {
    const {
      basicInfos,
      editor
    } = this.props
    return (
      <div className="report-basic-info" id="basicInfoAnchor">
        <label><span className="field-label">Report basic info</span></label>
        <div className="box report-basic-info-box">
          {!editor.isOpen &&
          <div className="column-wrapper">{basicInfos.filter((_, i) => (i + 1) % 2).map(info =>
            <div className="report-basic-info-item" key={info.id}>
              <label>{info.label}:</label> <span>{info.value}</span>
            </div>
          )}</div>}
          {!editor.isOpen &&
          <div className="column-wrapper">{basicInfos.filter((_, i) => i % 2).map(info =>
            <div className="report-basic-info-item" key={info.id}>
              <label>{info.label}:</label> <span>{info.value}</span>
            </div>
          )}</div>}
          {editor.isOpen &&
          <ReportBasicInfoEditor
            setDragRef={this.props.setDragRef}
            close={editor.close}
          />}
          <ReportDicomDateFormatter fields={['dob','studydate']} basicInfos={basicInfos}/>
          {!editor.isOpen && <a className="button small-button edit-button" onClick={editor.open}>Edit</a>}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/javascripts/report/ReportBasicInfo.jsx